import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as AuthModule from 'modules/auth';
import { LoadingScreen } from 'components/ui/LoadingScreen';

/** Only same-origin internal paths are honoured (mirrors the API's guard). */
function safeRedirect(path: string | null): string {
  if (!path || !path.startsWith('/') || path.startsWith('//')) return '/app';
  return path;
}

/** The API lands here with tokens in the URL **fragment**; we persist them, strip it, and route onward. */
const GoogleCallback: React.FC = () => {
  const navigate = useNavigate();
  const {
    methods: { setTokens },
  } = AuthModule.Context.useAuthContext();
  const handled = React.useRef(false);

  React.useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const accessToken = params.get('accessToken');
    const refreshToken = params.get('refreshToken');
    const redirect = safeRedirect(params.get('redirect'));

    // Strip the tokens out of the address bar before doing anything else.
    window.history.replaceState(null, '', window.location.pathname);

    if (accessToken && refreshToken) {
      setTokens({ accessToken, refreshToken });
      navigate(redirect, { replace: true });
    } else {
      navigate('/login?error=google_failed', { replace: true });
    }
  }, [navigate, setTokens]);

  return <LoadingScreen />;
};

export default GoogleCallback;
